import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {UrlService} from '../../services/url.service';
import {AmenitiesService} from '../../services/amenities.service';
import {AuthenticationService} from '../../services/authentication.service';
import {ResidentService} from '../../services/resident.service';
import {flatMap, takeUntil, tap} from 'rxjs/operators';
import {Subject} from 'rxjs/Subject';

@Component({
    templateUrl: 'amenities.component.html',
})
export class AmenitiesComponent implements OnInit, OnDestroy {
    residentBuildings: any = [];
    amenitiesData: any[] = [];
    $destroy = new Subject();

    constructor(public amenitiesService: AmenitiesService,
                public urlService: UrlService,
                public authenticationService: AuthenticationService,
                private residentService: ResidentService
    ) {
    }

    ngOnInit() {
        this.amenitiesService.view = this.authenticationService.isUserAdmin() ? 'list' : 'calendar';
        this.urlService.setQueryParams('allAmenities');
        this.urlService.onUrlChange
            .pipe(
                tap(() => this.amenitiesService.tabId = this.urlService.queryParams['tab']),
                flatMap(() => this.amenitiesService.getDataByQueryParams(true)
                    .pipe(
                        takeUntil(this.urlService.instantOnUrlChange)
                    )
                ),
                takeUntil(this.$destroy)
            )
            .subscribe();

        if (this.authenticationService.userIsResident) {
            this.residentService.getBuildingsInfo()
                .then(() => this.amenitiesService.getAmenitiesList())
                .then(() => {
                    if (this.amenitiesService.view == 'list')
                        this.amenitiesService.getData(true);
                    else {
                        if (this.authenticationService.userIsResident)
                            this.amenitiesService.getAmenitiesForCalendarResident();
                        else
                            this.amenitiesService.getAmenitiesForCalendar();
                    }
                });
        } else {
            this.amenitiesService.getAmenitiesList();
            this.amenitiesService.getBuildings();
        }
    }

    ngOnDestroy() {
        this.removeAllObservers();
        this.amenitiesService.resetData();
        this.urlService.resetQueryParams();
        this.$destroy.next();
    }

    removeAllObservers() {
        this.urlService.onUrlChange.observers = [];
    }

    onAmenitiesChange(event) {
        if (this.amenitiesData.indexOf(event) === -1) {
            this.amenitiesData.push(event);
        }
        this.amenitiesData.forEach((item, index) => {
            if (!item.checked) this.amenitiesData.splice(index, 1);
        });
    }

    changeView(view) {
        this.amenitiesService.view = view;
        if (view == 'calendar') {
            this.amenitiesService.data.allAmenities.data.forEach(i => i.checked = false);
            this.amenitiesService.selectedItemData = null;
            this.amenitiesService.showDetailedView = false;
        }
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.amenitiesService.emptyRowService.fillEmptyRow();
    }

    newBooking() {
        this.amenitiesService.isAmenityModalShow = true;
        if (this.amenitiesService.selectedItemData) {
            this.amenitiesService.selectedItemData.checked = false;
        }
    }
}





// WEBPACK FOOTER //
// /app/src/app/views/amenities/amenities.component.ts